import { render } from "./BloxupLogo.vue?vue&type=template&id=f53dde5c&scoped=true&ts=true"
import script from "./BloxupLogo.vue?vue&type=script&lang=ts"
export * from "./BloxupLogo.vue?vue&type=script&lang=ts"

import "./BloxupLogo.vue?vue&type=style&index=0&id=f53dde5c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53dde5c"]])

export default __exports__